import { FormHelperText } from '@mui/material';
// import { Editor } from '@tinymce/tinymce-react';
import Editor from 'src/components/editor';
import { FormControl } from '.';
import PropTypes from "prop-types";

const TextBox = (props) => {
    const { name, value, fullWidth, helperText } = props
    return (
        <FormControl
            key={`key${name}`}
            error={helperText ? true : false}
            fullWidth={fullWidth}
        >
            {/* <InputLabel>{label}</InputLabel> */}


            {/* <Editor
                apiKey={process.env.NEXT_PUBLIC_HTML_EDITOR_KEY}
                disabled={disabled}
                value={value}
                init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help'
                }}
                onEditorChange={e => props.onChange(e)}
            /> */}

            <Editor id="full-editor" value={value} onChange={(value) => props.onChange(value)} />

            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    )
};
TextBox.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
  };

export default TextBox;